<!-- 主题组件 -->
<template>
  <div>
    <div class="title title1">
      <img
        src="static/images/yingWu.png"
        style=" height:8rem; float:left; display: block; position: relative;z-index:3;margin-top: -2rem;margin-left: -2.7rem;"
      />
      <div
        style="background-color: white; height:5rem; width: 100%; position: relative;z-index:2;margin-top: 1rem;"
      >
        <div
          style="width: 8rem;height: 100%; background: rgba(0, 0, 0, 0) radial-gradient(circle, rgba(12, 28, 48, 0.8), rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.1)) repeat scroll 0% 0%;"
        ></div>
      </div>
      <div style="height: 1rem;background-color: white;"></div>
    </div>
    <div style="background-color: rgba(99, 102, 117, 0.5); padding-bottom: 20px;">
      <div v-if="pageStr === 'mainPostListPage'">
        <div class="showContent" id="showContent">
          <el-scrollbar style="height: 100%; width: 100%;border-radius: 0.1rem;">
            <div
              v-for="(post, index) in dataJsonArray"
              v-bind:key="post.postId"
              class="feedbackList"
            >
              <onePostShowCom
                :index="index"
                :post="post"
                v-on:flushFirstPageDataListEvent="flushFirstPageListFun"
              ></onePostShowCom>
            </div>
          </el-scrollbar>
        </div>
        <div class="pagesAndAddButtonLayoutClass">
          <div id="fbPage">
            <el-pagination
              popper-class="mainPostListPageComponentClass"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="sum"
            >
            </el-pagination>
          </div>
          <div id="fbDiv">
            <el-button size="small" type="primary" @click="showSaveComponent"
              >留 言</el-button
            >
          </div>
        </div>
      </div>
      <div v-else-if="pageStr === 'saveMainContentPage'">
        <mainPostAddCom
          :componentFunction="'save'"
          v-on:flushNowPostListEvent="flushFirstPageListFun"
          v-on:goBackEvent="pageStr = 'mainPostListPage'"
        ></mainPostAddCom>
      </div>
      <div v-else>
        无法解析此数据, 请退出后刷新重试!
      </div>
    </div>
  </div>
</template>

<script>
import mainPostAddCom from './mainPost/postUpdateOrSave.vue'
import onePostShowCom from './mainPost/onePostShow.vue'
export default {
  mounted () {
    this.flushDataList()
  },
  data () {
    return {
      sum: 0,
      nowPage: 1,
      pageSize: 10,
      dataJsonArray: null,
      pageStr: 'mainPostListPage',
      choosedMainPostId: 0,
      choosedMainPostContent: ''
    }
  },
  methods: {
    flushDataList () {
      const api = '/md/front/bbs/feedback/all/mains'
      const params = {
        nowPage: this.nowPage,
        pageSize: this.pageSize
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.dataJsonArray = res.data.list
          this.sum = res.data.sum
        }
      })
    },
    handleCurrentChange (nowPage) {
      this.nowPage = nowPage
      this.flushDataList()
    },
    handleSizeChange (newPageSize) {
      this.pageSize = newPageSize
      this.flushDataList()
    },
    showSaveComponent () {
      this.pageStr = 'saveMainContentPage'
    },
    flushFirstPageListFun () {
      this.nowPage = 1
      this.flushDataList()
    }
  },
  components: {
    mainPostAddCom,
    onePostShowCom
  }
}
</script>

<style scoped>
.showContent {
  margin-bottom: 1rem;
  height: 60vh;
}
.feedbackList {
  text-align: left;
  border-radius: 0.1rem;
}
.pagesAndAddButtonLayoutClass {
  display: flex;
  justify-content: center;
}
.title {
  text-align: left;
}
.title1 {
  font-size: 2rem;
}

#fbDiv {
  padding-left: 40px;
}

#showContent :deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
#fbPage :deep(.el-pager li) {
  background-color: transparent;
  font-size: 16px;
  color: #fff;
}

#fbPage :deep(.el-pagination .btn-next),
#fbPage :deep(.el-pagination .btn-prev) {
  background-color: transparent;
  color: #fff;
}
#fbPage :deep(.el-pagination button:disabled) {
  background-color: transparent;
}
#fbPage :deep(.el-pagination) {
  color: #fff;
}
#fbPage :deep(.el-pagination__total) {
  font-weight: 500;
  color: #f5f7fa;
}
#fbPage :deep(.el-pagination__jump) {
  font-weight: 500;
  color: #fff;
}
#fbPage :deep(.el-pagination .btn-next .el-icon),
#fbPage :deep(.el-pagination .btn-prev .el-icon) {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background-color: transparent;
}
#fbPage :deep(.el-pager li.active) {
  color: blue;
}
#fbPage :deep(.el-pager li.btn-quicknext),
#fbPage :deep(.el-pager li.btn-quickprev) {
  line-height: 28px;
  color: #fff;
}

#fbPage :deep(.el-input__inner) {
  background-color: transparent;
  color: #fff;
}

#fbPage :deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
</style>
